import React from 'react';

const About: React.FC = () => {
  return (
    <div className="container-fluid py-5 about bg-light">
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
            <div className="video border">
            </div>
          </div>
          <div className="col-lg-7 wow fadeIn" data-wow-delay="0.3s">
            <h4 className="text-primary mb-4 border-bottom border-primary border-2 d-inline-block p-2 title-border-radius">Về chúng tôi</h4>
            <h1 className="text-dark mb-4 display-5">Chào mừng bạn đến với Alana English!</h1>
            <p className="text-dark mb-4">
              Trung tâm Anh ngữ Alana cam kết mang đến cho học viên những trải nghiệm học tốt nhất và xây dựng nền tảng vững chắc cho sự phát triển toàn diện. 
              Với đội ngũ giáo viên chất lượng, chúng tôi không chỉ giảng dạy kiến thức ngôn ngữ mà còn tập trung vào việc phát triển kỹ năng giao tiếp và sự tự tin.
            </p>
            <div className="row mb-4">
              <div className="col-lg-6">
                <h6 className="mb-3"><i className="fas fa-check-circle me-2"></i>Phát âm chuẩn</h6>
                <h6 className="mb-3"><i className="fas fa-check-circle me-2 text-primary"></i>Tự tin giao tiếp</h6>
                <h6 className="mb-3"><i className="fas fa-check-circle me-2 text-secondary"></i>Cam kết đầu ra</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 